"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameVars_1 = require("./../GameVars");
var GameConstants_1 = require("../GameConstants");
var WaitingServerLayer = /** @class */ (function (_super) {
    __extends(WaitingServerLayer, _super);
    function WaitingServerLayer(game) {
        var _this = _super.call(this, game, null, "waiting-server-layer") || this;
        _this.visible = false;
        _this.bck = new Phaser.Sprite(_this.game, 0, 0, _this.game.cache.getBitmapData(GameConstants_1.GameConstants.BLACK_SQUARE));
        _this.bck.scale.set(GameConstants_1.GameConstants.GAME_WIDTH / GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.GAME_HEIGHT / GameConstants_1.GameConstants.BITMAP_SIZE);
        _this.bck.alpha = .0001;
        _this.bck.inputEnabled = true;
        _this.bck.events.onInputDown.add(_this.bckDown, _this);
        _this.add(_this.bck);
        var text = new Phaser.Text(_this.game, GameConstants_1.GameConstants.GAME_WIDTH / 2, GameConstants_1.GameConstants.GAME_HEIGHT - 20, "WAITING SERVER...", { font: "40px Futura", fill: "#ffffff" });
        text.scale.y = GameVars_1.GameVars.scaleY;
        text.anchor.set(.5, 1);
        _this.add(text);
        return _this;
    }
    WaitingServerLayer.prototype.show = function () {
        var _this = this;
        this.visible = true;
        this.alpha = 0;
        setTimeout(function () {
            _this.alpha = 1;
        }, 1000);
    };
    WaitingServerLayer.prototype.bckDown = function () {
        // nothing to do
    };
    return WaitingServerLayer;
}(Phaser.Group));
exports.WaitingServerLayer = WaitingServerLayer;
